import {useAttendeeVariables} from 'Event'
import {useAddTranslation} from 'Event/LanguageProvider'
import {useTemplate} from 'Event/TemplateProvider'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import HTMLEditor, {HTMLEditorContainer} from 'lib/ui/form/HTMLEditor'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import React from 'react'
import {Controller} from 'react-hook-form'

export default function WaiverConfig() {
  const {waiver} = useTemplate()
  const save = useSaveTemplate()
  const addTranslation = useAddTranslation()
  const v = useAttendeeVariables()

  const {
    form: {control},
  } = useConfig()

  const handleSave = (data: any) => {
    const description = replaceAtPath(
      data,
      'waiver.description',
      '{{waiver_description}}',
    )
    save({
      ...data,
      localization: addTranslation({
        waiver_description: description ?? '',
      }),
    })
  }

  return (
    <Config title="Description" onSave={handleSave}>
      <SettingsPanel>
        <HTMLEditorContainer>
          <Controller
            name="waiver.description"
            defaultValue={v(waiver.description)}
            control={control}
            render={({value, onChange}) => (
              <HTMLEditor data={value} onChange={onChange} />
            )}
          />
        </HTMLEditorContainer>
      </SettingsPanel>
    </Config>
  )
}
